// The email a half-finished signup is waiting to verify, plus the send-otp
// handle that goes with it.
//
// Before this existed, register wrote the address to localStorage "email" while
// the verification screen read "userEmail" - a key only login and Google
// sign-in ever wrote. So Resend on a fresh signup sent no address at all and the
// API answered "The email field is required.", and on a browser where somebody
// had signed in before it would have resent the code to that OLD address.
//
// One key now, written by every entry point, read with fallbacks so a session
// already mid-signup when this shipped still resolves.

const EMAIL_KEY = "pending_signup_email";
const TOKEN_KEY = "email_token";

export const setPendingSignupEmail = (email) => {
  if (!email) return;
  try {
    localStorage.setItem(EMAIL_KEY, email);
    // Kept in step for the older readers elsewhere in the app.
    localStorage.setItem("email", email);
    localStorage.setItem("userEmail", email);
  } catch (e) {}
};

export const getPendingSignupEmail = () => {
  try {
    const stored =
      localStorage.getItem(EMAIL_KEY) ||
      localStorage.getItem("email") ||
      localStorage.getItem("userEmail");
    if (stored) return stored;
    return JSON.parse(localStorage.getItem("userInfo") || "null")?.email || "";
  } catch (e) {
    return "";
  }
};

// The server-issued handle from send-otp. It can legitimately be missing (the
// code was requested from another browser, or the send was rate-limited), which
// is why verify-otp now also accepts the email.
export const setVerificationToken = (token) => {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token);
  } catch (e) {}
};

export const getVerificationToken = () => {
  try {
    return localStorage.getItem(TOKEN_KEY) || "";
  } catch (e) {
    return "";
  }
};

export const clearPendingSignup = () => {
  try {
    localStorage.removeItem(EMAIL_KEY);
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem("email");
  } catch (e) {}
};
